import { useClassStore } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { action, computed } from 'mobx';

import container from '../../ioc/ioc';

import { JourneysStore } from '~stores/journeys';
import { NavigationStore } from '~stores/navigation';

@injectable()
class ControlPanelPresenter {
  @inject(JourneysStore) private journeysStore!: JourneysStore;
  @inject(NavigationStore) private _navigator2Store!: NavigationStore;

  @computed get showControlPanel(): boolean {
    return this._navigator2Store.currentParams.value?.journey === 'floor';
  }

  @action public readonly handleOwnableLogoPress = () => {
    this._navigator2Store.resetNav().then();
  };
}

const useControlPanelPresenter = () =>
  useClassStore<ControlPanelPresenter>(container.get(ControlPanelPresenter));

export default useControlPanelPresenter;
